export default __webpack_public_path__ + "empty-clock.d7220849.svg";